import HttpClient from "./HttpClient.js";
import PdfTemplateBox from "./PdfTemplateBox.js";
import PdfTemplateImage from "./PdfTemplateImage.js";
import PdfTemplateQrCode from "./PdfTemplateQrCode.js";
import PdfTemplateText from "./PdfTemplateText.js";
export default class PdfTemplate {
    constructor(template) {
        this.id = template.id;
        this.name = template.name;
        this.width = parseInt(template.width);
        this.height = parseInt(template.height);
        this.margin_left = parseInt(template.margin_left);
        this.margin_top = parseInt(template.margin_top);
        this.company_id = template.company_id;
        this.created_at = template.created_at;
        this.updated_at = template.updated_at;
        this.boxes = PdfTemplateBox.getBoxes(template.boxes);
        this.images = PdfTemplateImage.getImages(template.images);
        this.qr_codes = PdfTemplateQrCode.getQrCodes(template.qr_codes);
        this.texts = PdfTemplateText.getTexts(template.texts);
    }

    static async loadTemplates() {
        const client = new HttpClient();
        const response = await client.instance.get('pdf-templates');
        const templates = [];
        response.data.forEach(template => {
            templates.push(new PdfTemplate(template));
        });
        return templates;
    }

    static async createTemplate(data) {
        const client = new HttpClient();
        const response = await client.instance.post("pdf-templates", data);
        return response.data;
    }

    async update() {
        const client = new HttpClient();
        const response = await client.instance.put(`pdf-templates/${this.id}`, this);
        return response.data;
    }

    async delete() {
        const client = new HttpClient();
        const response = await client.instance.delete(`pdf-templates/${this.id}`);
        return response.data;
    }
}